import { render, staticRenderFns } from "./Genre.vue?vue&type=template&id=37141324&scoped=true&"
import script from "./Genre.vue?vue&type=script&lang=js&"
export * from "./Genre.vue?vue&type=script&lang=js&"
import style0 from "./Genre.vue?vue&type=style&index=0&id=37141324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37141324",
  null
  
)

export default component.exports